export default {
    '1d-diagram3': {
        'diagram-task': 'Type your answer in the white box.<br>Then click the ‘reveal’ button to see how it compares to the correct answer',
        'diagram-description': `<li>A memory becomes firmly established through a process called consolidation</li>
          <li>In its early phases, memory storage is dynamic and sensitive to disruption</li>
          <li>The idea of memory consolidation is supported by clinical observation</li>
          <li>Injuries and concussion can lead to a memory loss called retro-grade amnesia</li>`,
        'fixed-answer1': 'In early phases, memory storage is dynamic and sensitive to disruption',
        'fixed-answer2': 'For a memory to persist, it must be consolidated into long-term storage',
        'fixed-answer3': 'But first the memory must be stabilized in the brain',
        'fixed-answer4': 'Interrupting the stabilizing process causes the memory to disappear',
        'fixed-answer5': 'Thoroughly and deeply processed',
        'fixed-answer6': 'Linked to current knowledge',
        'fixed-answer7': 'Boxer injury to head',
        'fixed-answer8': 'Epileptic seizure'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1d/diagram3/i18n/en.js